import { createContext, useContext, type ReactNode } from "react";
import { useActiveEvent } from "@/hooks/use-event";
import type { EventWithDetails } from "@/types/database";

interface EventContextValue {
  event: EventWithDetails | null;
  isLoading: boolean;
  error: Error | null;
}

const EventContext = createContext<EventContextValue>({
  event: null,
  isLoading: true,
  error: null,
});

export function EventProvider({ children }: { children: ReactNode }) {
  const { data, isLoading, error } = useActiveEvent();

  return (
    <EventContext.Provider
      value={{
        event: data ?? null,
        isLoading,
        error: error as Error | null,
      }}
    >
      {children}
    </EventContext.Provider>
  );
}

export function useEvent() {
  const context = useContext(EventContext);
  if (context === undefined) {
    throw new Error("useEvent must be used within an EventProvider");
  }
  return context;
}
